<template>
  <div class="wrapper limit">
    <div class="info">
      <h4>WIJWETENDINGEN</h4>
      <div class="address">
        <p>Parade 29</p>
        <p>5311 KL, 's-Hertogenbosch</p>
      </div>

      <div class="company-numbers">
        <b>KVK</b>
        <p>77797159</p>
        <!-- <b>BTW</b>
        <p>0000000</p> -->
      </div>

      <h4>
        <a href="tel:0732020289">073 20 20 289</a>
      </h4>
      <h4>
        <a href="mailto:Iedereen@weetdingen.nl">iedereen@weetdingen.nl</a>
      </h4>

      <div class="links">
        <b>
          <a href="https://www.linkedin.com/in/wij-weten-dingen-236a951a3/">linkedin.com/wijwetendingen</a>
        </b>
        <!-- <b>
          <a href="#">twitter/wijwetendingen</a>
        </b> -->
        <b>
          <a href="https://www.facebook.com/Wijwetendingen-111115327172427">facebook/wijwetendingen</a>
        </b>
      </div>
    </div>
    <div class="map">
      <div style="width: 100%">
        <iframe
          src="https://maps.google.com/maps?&hl=nl&q=parade%2029+(Wij%20Weten%20Dingen)&ie=UTF8&t=&z=18&iwloc=B&output=embed"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
        >
          <a href="https://www.mapsdirections.info/nl/maak-een-google-map/">Maak een Google Map</a> van
          <a href="https://www.mapsdirections.info/nl/">Nederland Kaart</a>
        </iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {},
  components: {}
};
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;

  height: 500px;

  display: grid;
  grid-template-columns: 1fr 2.5fr;

  @media screen and (max-width: 950px) {
    grid-template-columns: 1fr;
    min-height: 500px;
    height: unset;
  }

  .info {
    padding: 40px;
    padding-top: 50px;
    padding-bottom: 50px;
    background-color: white;

    display: grid;
    grid-template-columns: 1fr;

    h4 {
      text-transform: uppercase;
      font-size: 19px;

      a {
        text-decoration: none;
      }
    }

    .links {
      display: grid;
      grid-template-columns: 1fr;

      margin-top: 10px;
    }

    .company-numbers {
      display: grid;
      max-width: 50%;
      grid-template-columns: 1fr 1fr;

      margin-top: 10px;
      margin-bottom: 20px;
    }

    a {
      color: black;
      text-transform: uppercase;
    }
  }

  .map {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  iframe {
    min-height: 500px;
    width: 100%;
  }
}
</style>
